import { render, staticRenderFns } from "./Notifications.vue?vue&type=template&id=7374b8b2&scoped=true&"
import script from "./Notifications.vue?vue&type=script&lang=js&"
export * from "./Notifications.vue?vue&type=script&lang=js&"
import style0 from "@@/core/components/shared/Notifications/NotificationsStyle.css?vue&type=style&index=0&id=7374b8b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7374b8b2",
  null
  
)

export default component.exports